import i18n from '@/locales/i18n';

/**
 * Available languages
 */
export const LANGUAGES = {
  EN: 'en',
  FR: 'fr',
} as const;

export type Language = (typeof LANGUAGES)[keyof typeof LANGUAGES];

/**
 * Language metadata for UI display
 */
export const LANGUAGE_OPTIONS = [
  { code: LANGUAGES.EN, label: 'English', nativeLabel: 'English' },
  { code: LANGUAGES.FR, label: 'French', nativeLabel: 'Français' },
] as const;

/**
 * Change the application language
 */
export const changeLanguage = (lang: Language) => {
  return i18n.changeLanguage(lang);
};

/**
 * Get the current language
 */
export const getCurrentLanguage = (): Language => {
  return i18n.language as Language;
};

/**
 * Get language display name
 */
export const getLanguageLabel = (code: Language, native = false): string => {
  const option = LANGUAGE_OPTIONS.find((opt) => opt.code === code);
  return native ? (option?.nativeLabel ?? code) : (option?.label ?? code);
};
